<template>
    <div class="detail-wrap"  id="caseDetailPages" >
        <div class="title-bgc">
            <div class="tips-wrap">
                <img src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/business/detail_head.png" alt="">
                <div>A.O.史密斯商用净水优质案例</div>
            </div>
            <img :src="sBuildImg" alt="">
        </div>
        <div class="info-wrap">
            <div class="title">{{objInfo.title}}</div>
            <div class="item-info-wrap">
                <template v-for="(item,index) in arrInfo">
                    <div class="item-info" v-if="item.isShow">
                        <div  class="img-wrap">
                            <img :src="'https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/business/'+item.icon" mode="" />
                            <span>{{item.name}}：</span>
                        </div>
                        <div class="text">{{item.value}}</div>
                    </div>
                </template>
                <div class="code-screen">
                    <img :src="wxQrCode" alt="">
                </div>
            </div>
        </div>
        <div class="common-wrap" v-if="arrImg.length>0">
            <div class="common-title">
                <span class="devices">Using devices</span>
                <div class="title-info">
                    <img src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/business/icon08.png" mode="" />
                    <span>使用设备</span>
                    <img src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/business/icon09.png" mode="" />
                </div>
            </div>
            <div class="img-wrap">
                <div class="img-item" :class="{'img-item-more':arrImg.length>4}" :style="{'background':item.type==2?`url(${item.url}) no-repeat center/cover`:'#f8f8f8'}" v-for="(item,index) in arrImg" :key="index">
                    <!--                    <img :src="item.url" v-if="item.type==2" />-->
                    <video :src="item.url" v-if="item.type!=2" />
                </div>
            </div>
        </div>
        <div class="common-wrap" v-if="objInfo.feedback">
            <div class="common-title">
                <span class="devices">client feedback</span>
                <div class="title-info">
                    <img src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/business/icon08.png" mode="" />
                    <span>客户反馈</span>
                    <img src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/business/icon09.png" mode="" />
                </div>
            </div>
            <div class="feedback-wrap">
                <img src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/business/icon10.png" class="icon_10" mode="" />
                <img src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/business/icon11.png" class="icon_11" mode="" />
                <span>{{objInfo.feedback}} </span>
            </div>
        </div>
        <div class="common-wrap"  v-if="objInfo.advantage">
            <div class="common-title">
                <span class="devices">client feedback</span>
                <div class="title-info">
                    <img src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/business/icon08.png" mode="" />
                    <span>方案优势</span>
                    <img src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/business/icon09.png" mode="" />
                </div>
            </div>
            <div class="addvage-wrap">
                <span>{{objInfo.advantage}}</span>
                <img src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/business/icon12.png" mode="" />
            </div>
        </div>
        <div class="common-wrap" v-if="objInfo.push_title">
            <div class="common-title">
                <span class="devices">RELATED ARTICLES</span>
                <div class="title-info">
                    <img src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/business/icon08.png" mode="" />
                    <span>相关推文</span>
                    <img src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/business/icon09.png" mode="" />
                </div>
            </div>
            <div class="pull-wrap">
                <div class="pull-img">
                    <img :src="objInfo.push_img" mode="aspectFill" />
                </div>
                <div class="pull-title">{{objInfo.push_title}}</div>
            </div>
        </div>
        <div class="common-wrap">
            <div class="common-title">
                <span class="devices">product details</span>
                <div class="title-info">
                    <img src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/business/icon08.png" mode="" />
                    <span>产品详情</span>
                    <img src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/business/icon09.png" mode="" />
                </div>
            </div>
            <div class="product-wrap" v-if="arrGoods.length>0">
                <div class="product-item" v-for="(item,index) in arrGoods" :key="index">
                    <div class="product-img">
                        <img :src="item.info.mobile_img" />
                    </div>
                    <div class="product-title">{{item.cate_name}}</div>
                    <div class="product-tag">{{item.info.goods_name}}</div>
                    <div class="btn">
                        <span>查看同款商品</span>
                        <img src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/business/icon16.png" mode="" />
                    </div>
                </div>
            </div>
        </div>
        <div class="more-case" bindtap="toList">
            <span>查看更多相似案例</span>
            <img src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/business/icon13.png" mode="" />
        </div>
    </div>
</template>

<script>
import oRequest from "@/libsV2/request";
import html2canvas from "html2canvas";

export default {
    name: "info",
    data(){
        return {
            objInfo:{
                feedback:'',
                advantage:''
            },//案例详情
            arrInfo: [
                { id: 1, name: '所属城市', value: '', icon: 'icon01.png',key:'city_name',isShow:true },
                { id: 2, name: '所属行业', value: '', icon: 'icon02.png',key:'industry_name',isShow:true },
                { id: 3, name: '服务人数', value: '', icon: 'icon03.png' ,key:'people_served_count_name',isShow:true },
                // { id: 4, name: '服务时间', value: '', icon: 'icon04.png',key:'install_month',isShow:true },
                { id: 5, name: '采购方式', value: '', icon: 'icon05.png' ,key:'purchase_type_name',isShow:true},
                { id: 6, name: '装机时间', value: '', icon: 'icon06.png' ,key:'install_time',isShow:true},
                { id: 7, name: '原饮水方式', value: '', icon: 'icon07.png',key:'water',isShow:true },
            ],
            arrImg:[],
            arrGoods:[],
            arrWterType:[],
            wxQrCode:'',
            sBuildImg:'',
        }
    },
    mounted() {
        this.$store.commit('loadSwitch',true)
        const data = this.$route.query.info || JSON.stringify({
            user_id: 491,
            topic_id: 196,
            type: 'draft_id',
        });
        const _data = JSON.parse(data);
        $init(() => {
            oRequest.getData('bus/topic/index/getConfig').then(res => {
                this.arrWterType=res.data.data.result.water_type
                oRequest.getData('bus/topic/index/topic', _data).then(res => {
                    const {data: {data: {result}}} = res;
                    this.arrGoods=result.goods
                    this.objInfo=result
                    this.sBuildImg =result.scenes[0].image_url && result.scenes[0].image_url[0].url
                    this.arrInfo.forEach(it=>{
                        if(it.key=='industry_name'){
                            it.value=result[it.key].join(',')
                        }else{
                            it.value=result[it.key]
                        }
                        if(it.key=='purchase_type_name' && result.show_purchase!=1){
                            it.isShow=false
                        }
                        if(it.key=='install_time' && result.show_install!=1){
                            it.isShow=false
                        }
                        if(it.key=='water'){
                            let arrWater=result.water_type.split(',')
                            let arrWaterFilter=[]
                            this.arrWterType.forEach(it=>{
                                if(arrWater.includes(Number(it.id)) || arrWater.includes(String(it.id))){
                                    arrWaterFilter.push(it.val)
                                }
                            })
                            it.value=arrWaterFilter.join(',')
                            if(!it.value){
                                it.isShow=false
                            }
                        }
                    })
                    let arrImg=[]
                    result.scenes.forEach(it=>{
                        if(it.image_url && it.image_url.length){
                            arrImg=[...arrImg,...it.image_url]
                        }
                    })
                    this.arrImg=arrImg
                    console.log(arrImg,'图片')
                    oRequest.getData('/comm/qrcode/get', {
                        type: 1,
                        is_hyaline:1,
                        version:'trial',// 生成体验版码
                        page: 'subcontract/pages/business/case/detailv2/detail',
                        param:`user_id=${_data.user_id}&id=${_data.topic_id}&topicid=${_data.topic_id}&scource=xcx&track_action=bus_topic_share&track_id=${_data.topic_id}&track_uuid=${this.$route.query.track_uuid}&type=draft_id`
                    }).then((res) => {
                        this.$store.commit('loadSwitch',false)
                        const {data: {data: {result:{url}}}} = res;
                        this.wxQrCode = url;
                        const timer = setTimeout(() => {
                            html2canvas(document.querySelector("#caseDetailPages"), {
                                useCORS: true,
                            }).then(c => {
                                console.log(c.toDataURL(),'图片')
                                wx.miniProgram.postMessage({data: {base64: c.toDataURL()}});
                                wx.miniProgram.navigateBack();
                            });
                            clearTimeout(timer);
                        }, 1500);
                    });


                });
            })
        })
    }
}
</script>

<style scoped lang="scss">
.code-screen {
    position: absolute;
    border-radius: 10px;
    width: 136px;
    height: 136px;
    right: 28px;
    bottom: 28px;

    img {
        max-width: 100%;
        height: 100%;
        display: block;
        margin: auto;
    }
}
.detail-wrap{
    width: 100%;
    background: #F2F3F7;
    padding-bottom: 190px;
}
.detail-wrap .title-bgc{
    width: 100%;
    position: relative;
    //height: 1000px;
    //background: url('https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/business/bgcpng.png') no-repeat top/cover;
}
.detail-wrap .title-bgc .tips-wrap{
    width: 100%;
    height: 82px;
    // background: url('https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/business/bgc_title.png') no-repeat top/cover;
    // background: url('https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/business/detail_head.png') no-repeat top/cover;
    text-align: center;
    font-size: 30px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 82px;
    position: absolute;
    top: 0;
    left: 0;

    img {
        width: 100%;
        height: 100%;
    }

    div {
        width: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
.detail-wrap .title-bgc img{
    width: 100%;
}
.detail-wrap .info-wrap{
    position: relative;
    z-index: 2;
    width: 697px;
    background: #FFFFFF;
    box-shadow: 0px 1px 11px 0px rgba(93,97,112,0.1);
    border-radius: 10px;
    margin: -190px auto 0;
    padding: 30px 26px;
    position: relative;
}
.detail-wrap .info-wrap .title{
    font-size: 36px;
    font-weight: 600;
    color: #000000;
}
.detail-wrap .info-wrap .item-info-wrap{
    margin-top: 36px;
}
.detail-wrap .info-wrap .item-info .text{
    font-size: 25px;
    font-weight: 400;
    color: #666666;
    padding-left: 10px;
}
.detail-wrap .info-wrap .item-info .img-wrap{
    display: flex;
    min-width: 158px;
}
.detail-wrap .info-wrap .item-info .img-wrap img{
    margin-top: 4px;
}
.detail-wrap .info-wrap .item-info{
    display: flex;
    margin-bottom: 28px;
}
.detail-wrap .info-wrap .item-info:last-child{
    margin: 0;
}
.detail-wrap .info-wrap .item-info div{
    display: flex;
}
.detail-wrap .info-wrap .item-info img{
    width: 25px;
    height: 25px;
}
.detail-wrap .info-wrap .item-info span{
    font-size: 25px;
    font-weight: 400;
    display: block;
    color: #666666;
    padding-left: 10px;
    white-space: nowrap;
}
.common-wrap{
    margin-top: 56px;
}
.common-wrap .common-title{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.common-wrap .common-title .devices{
    font-size: 24px;
    font-weight: bold;
    color: rgba(48, 133, 68, 0.3);
}
.common-wrap .common-title .title-info{
    display: flex;
    align-items: center;
}
.common-wrap .common-title .title-info img{
    width:112px;
    height: 14px;
}
.common-wrap .common-title .title-info span{
    font-size: 37px;
    font-weight: 600;
    padding: 0 27px;
    color: #212121;
}
.common-wrap  .img-wrap{
    width: 697px;
    background: #FFFFFF;
    border-radius: 10px;
    margin:28px auto 0;
    padding: 27px 24px;
    display: flex;
    flex-wrap: wrap;
}
.common-wrap .img-wrap .img-item{
    width: 311px;
    height: 311px;
    border-radius: 7px;
    background-color: #f8f8f8;
    margin-right: 22px;
    display: flex;
    align-items: center;
    overflow: hidden;
    margin-bottom: 22px;
    overflow: hidden;
}
.common-wrap .img-wrap img{
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.common-wrap .img-wrap video{
    width: 311px;
    height: 311px;

}
.common-wrap .img-wrap .img-item-more{
    width: 207px;
    height: 207px;
    margin-right: 12px;
    margin-bottom: 12px;
}
.common-wrap .img-wrap .img-item img{
    width: 100%;
}
.common-wrap .img-wrap .img-item:nth-child(2n){
    margin: 0;
}
.common-wrap .img-wrap .img-item-more:nth-child(2n){
    margin-right: 12px;
    margin-bottom: 12px;
}
.common-wrap .img-wrap .img-item-more:nth-child(3n){
    margin: 0;
}
.feedback-wrap{
    width: 744px;
    min-height: 646px;
    background: url('https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/business/deedback_bgc.png') no-repeat top/cover;
    margin: 0 auto;
    padding: 120px 100px;
    position: relative;
    font-size: 27px;
    font-weight: 400;
    color: #333333;
}
.feedback-wrap span{
    line-height: 64px;
}
.feedback-wrap .icon_10{
    position: absolute;
    width: 45px;
    height: 43px;
    top: 55px;
    left: 63px;
}
.feedback-wrap .icon_11{
    position: absolute;
    width: 45px;
    height: 43px;
    bottom: 80px;
    right: 82px;
}
.addvage-wrap{
    width: 697px;
    min-height: 633px;
    background: url('https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/business/deedback_bgc02.png') no-repeat top/cover;
    margin: 30px auto 0;
    padding: 88px 67px 231px;
    position: relative;
}
.addvage-wrap span{
    font-size: 27px;
    font-weight: 400;
    color: #333333;
    line-height: 48px;
}
.addvage-wrap img{
    position: absolute;
    width: 192px;
    height: 128px;
    bottom: 104px;
    right: 45px;
}
.pull-wrap{
    width: 697px;
    background: #FFFFFF;
    box-shadow: 0px 3px 27px 0px rgba(93,97,112,0.15);
    border-radius: 10px;
    padding: 24px 28px;
    margin: 30px auto 0;
}
.pull-wrap .pull-img{
    width: 100%;
    height: 362px;
    background: #f8f8f8;
    border-radius: 7px;
    overflow: hidden;
    display: flex;
    align-items: center;
}
.pull-wrap .pull-img img{
    width: 100%;
}
.pull-wrap  .pull-title{
    font-size: 28px;
    font-weight: 400;
    color: #212121;
    margin-top: 30px;
}
.product-wrap{
    width: 697px;
    margin: 30px auto 0;
    display: flex;
    flex-wrap: wrap;
}
.product-wrap .product-item{
    width: 337px;
    //height: 547px;
    background: #FFFFFF;
    padding: 14px 17px 40px;
    box-shadow: 0px 3px 27px 0px rgba(93,97,112,0.15);
    border-radius: 10px;
    text-align: center;
    margin-right: 22px;
    margin-bottom: 22px;
}
.product-wrap .product-item:nth-child(2n){
    margin-right: 0;
}
.product-wrap .product-item .product-img{
    width: 100%;
    height: 304px;
    border-radius: 12px;
    background: #F2F3F7;
    padding: 25px;
}
.product-wrap .product-item .product-img img{
    //width: 100%;
    height: 100%;
    //object-fit: contain;
}
.product-wrap .product-item .product-title{
    font-size: 28px;
    font-weight: 500;
    color: #212121;
    line-height: 19px;
    margin-top: 26px;
}
.product-wrap .product-item .product-tag{
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    margin-top: 20px;
    color: #666666;
}
.product-wrap .product-item  .btn{
    width: 227px;
    height: 57px;
    background: rgba(48, 133, 68, 0.1);
    border-radius: 29px;
    margin: 27px auto 0;
    display: flex;
    align-items: center;
    justify-content: center;
}
.product-wrap .product-item  .btn span{
    font-size: 25px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #308544;
    line-height: 57px;
    padding-right: 12px;
}
.product-wrap .product-item  .btn img{
    width: 11px;
    height: 19px;
}
.more-case{
    width: 697px;
    height: 93px;
    background: #FFFFFF;
    box-shadow: 0px 3px 27px 0px rgba(93,97,112,0.15);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px auto 0;
}
.more-case span{
    font-size: 28px;
    font-weight: 400;
    color: #212121;
    padding-right: 13px;
}
.more-case img{
    width: 31px;
    height: 31px;
}
</style>
